import Header from './components/Header';
import Workspace from './components/Workspace';
import logo from './assets/logo192.jpg';

import './App.css';

function App() {
  return (
    <div className="App">
        <Header logo={logo}></Header>
        <Workspace />
    </div>
  );
}

export default App;
